import { useState, useEffect } from 'react';
import { getRetrospectiveUrl } from '../utils/retrospectiveUrl';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { getAdminURL } from 'src/utils/organizationSettingsUrl';

export enum UrlType {
  PROJECT_URL,
  ADMIN_URL,
}

async function getReturnUrl(returnUrlType: UrlType): Promise<string> {
  return returnUrlType === UrlType.PROJECT_URL
    ? await getRetrospectiveUrl()
    : await getAdminURL();
}

const loadStripeCustomerPortalUrl = async (returnUrlType: UrlType) => {
  const firebaseFunctions = getFunctions();

  const searchFunction = httpsCallable<any, { portalUrl: string }>(
    firebaseFunctions,
    'getStripePortalSession'
  );

  const result = await searchFunction({
    returnUrl: await getReturnUrl(returnUrlType),
  });

  return result.data?.portalUrl;
};

export const useStripeCustomerPortal = (returnUrlType: UrlType) => {
  const [portalUrl, setPortalUrl] = useState('');
  const [retries, setRetries] = useState(0);

  useEffect(() => {
    if (portalUrl) return;
    (async () => {
      const url = await loadStripeCustomerPortalUrl(returnUrlType);
      if (url) setPortalUrl(url);
      else {
        setTimeout(() => {
          setRetries(retries + 1);
        }, 2000);
      }
    })();
  }, [portalUrl, returnUrlType, retries]);

  return { portalUrl };
};
